module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-form', {
    ref: "form",
    attrs: {
      "model": _vm.form,
      "label-width": "100px"
    },
    nativeOn: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.onSubmit($event)
      }
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": 30
    }
  }, [_c('el-col', {
    attrs: {
      "span": 19
    }
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box__header"
  }, [_c('span', {
    staticClass: "box__header--text"
  }, [_vm._v(_vm._s(_vm.getRouteName(_vm.$route)))]), _vm._v(" "), _c('form-language-switcher')], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Tytuł",
      "error": _vm.errors[_vm.addLanguageSuffix('title')],
      "required": ""
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.form[_vm.addLanguageSuffix('title')]),
      callback: function($$v) {
        _vm.$set(_vm.form, _vm.addLanguageSuffix('title'), $$v)
      },
      expression: "form[addLanguageSuffix('title')]"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Ukryj zdjęcie oraz treść w szczegółach"
    }
  }, [_c('el-switch', {
    model: {
      value: (_vm.form.hide_default_widget),
      callback: function($$v) {
        _vm.$set(_vm.form, "hide_default_widget", $$v)
      },
      expression: "form.hide_default_widget"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Tekst na kafelku",
      "error": _vm.errors[_vm.addLanguageSuffix('tile_text')]
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.form[_vm.addLanguageSuffix('tile_text')]),
      callback: function($$v) {
        _vm.$set(_vm.form, _vm.addLanguageSuffix('tile_text'), $$v)
      },
      expression: "form[addLanguageSuffix('tile_text')]"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Treść",
      "error": _vm.errors[_vm.addLanguageSuffix('description')]
    }
  }, [_c('wyswig-input', {
    model: {
      value: (_vm.form[_vm.addLanguageSuffix('description')]),
      callback: function($$v) {
        _vm.$set(_vm.form, _vm.addLanguageSuffix('description'), $$v)
      },
      expression: "form[addLanguageSuffix('description')]"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Tagi",
      "error": _vm.errors['tags']
    }
  }, [_c('el-select', {
    staticClass: "fluid",
    attrs: {
      "filterable": "",
      "multiple": "",
      "default-first-option": "",
      "placeholder": "Tagi",
      "allow-create": ""
    },
    model: {
      value: (_vm.form['tags']),
      callback: function($$v) {
        _vm.$set(_vm.form, 'tags', $$v)
      },
      expression: "form['tags']"
    }
  }, _vm._l((_vm.tags), function(item) {
    return _c('el-option', {
      key: item.name,
      attrs: {
        "label": item.name,
        "value": item.name
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Popup"
    }
  }, [_c('el-select', {
    attrs: {
      "filterable": "",
      "clearable": "",
      "placeholder": "Wybierz popup"
    },
    model: {
      value: (_vm.form.popup),
      callback: function($$v) {
        _vm.$set(_vm.form, "popup", $$v)
      },
      expression: "form.popup"
    }
  }, _vm._l((_vm.popups), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.working_name,
        "value": item.id
      }
    })
  }), 1)], 1), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "box__header box__header--photos"
  }, [_c('span', {
    staticClass: "box__header--text"
  }, [_vm._v("Zdjęcia:")])]), _vm._v(" "), _c('photo-cropper', {
    attrs: {
      "photo": _vm.form.photo,
      "errors": _vm.errors,
      "croppers": _vm.croppers
    },
    on: {
      "update:photo": function($event) {
        return _vm.$set(_vm.form, "photo", $event)
      },
      "update:croppers": function($event) {
        _vm.croppers = $event
      }
    }
  })], 1), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "box__header"
  }, [_c('span', {
    staticClass: "box__header--text"
  }, [_vm._v("Widgety - widoczne w szczegółach:")])]), _vm._v(" "), _c('widgets-input', {
    attrs: {
      "widgets": _vm.form.widgets,
      "lessDetails": true,
      "errors": _vm.errors.widgets || []
    },
    on: {
      "update:widgets": function($event) {
        return _vm.$set(_vm.form, "widgets", $event)
      }
    }
  })], 1)], 1)]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 5
    }
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box__header"
  }, [_vm._v("\n                        " + _vm._s(_vm.$t('manage')) + "\n                    ")]), _vm._v(" "), _c('el-form-item', {
    staticClass: "form__buttons",
    attrs: {
      "label-width": "0"
    }
  }, [_c('router-link', {
    attrs: {
      "to": _vm.redirectRoute
    }
  }, [_c('el-button', {
    staticClass: "fluid form__button"
  }, [_vm._v(_vm._s(_vm.$t('cancel')))])], 1), _vm._v(" "), _c('el-button', {
    staticClass: "fluid form__button",
    attrs: {
      "type": "primary",
      "loading": _vm.loading
    },
    on: {
      "click": _vm.onSubmit
    }
  }, [_vm._v("\n                            " + _vm._s(_vm.$t('submit')) + "\n                        ")]), _vm._v(" "), _c('div', {
    staticClass: "el-form-item timestamp"
  }, [_c('label', [_vm._v("\n                                Data publikacji\n                                "), (_vm.errors.timestamp) ? _c('div', {
    staticClass: "el-form-item__error"
  }, [_vm._v("\n                                    " + _vm._s(_vm.errors.timestamp) + "\n                                ")]) : _vm._e(), _vm._v(" "), _c('el-date-picker', {
    staticClass: "timestamp__input",
    attrs: {
      "clearable": false,
      "value-format": "yyyy-MM-dd HH:mm:ss",
      "type": "datetime",
      "placeholder": "Select date and time"
    },
    model: {
      value: (_vm.form.timestamp),
      callback: function($$v) {
        _vm.$set(_vm.form, "timestamp", $$v)
      },
      expression: "form.timestamp"
    }
  })], 1)]), _vm._v(" "), _c('label', [_vm._v("\n                            Ukryj\n                            "), _c('el-switch', {
    model: {
      value: (_vm.form.hide),
      callback: function($$v) {
        _vm.$set(_vm.form, "hide", $$v)
      },
      expression: "form.hide"
    }
  })], 1)], 1)], 1)])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-be08755a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/News/NewsForm.vue
// module id = 799
// module chunks = 0